export default "__VITE_ASSET__CBiaLx00__"